<div (click)="navigate()" class="ion-padding">
  <div class="smtileitem-wrapper" [ngStyle]="{'background-image': 'url(' + safeURL(basepath+'storage/app/media'+b.image) + ')'}">
      <h1 [ngStyle]="{'color': b.subtitle_color }" class="title-button" expand="full" [innerHTML]="b.title"></h1>
      <!-- <ion-icon *ngIf="data.ispageVisited(b.nav_id)" src="/assets/custom-ion-icons/check-mark.svg"></ion-icon> -->
      <ion-icon *ngIf="isboxVisited()" src="/assets/custom-ion-icons/check-mark.svg"></ion-icon>
  </div>
  <!-- <img [src]="basepath+'storage/app/media'+b.image" alt=""> -->
</div>